<template>
	<toolbar-search-view placeholder="Organisation" />
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>

</style>
